/**
 * Fitbox theme support for AngularJS
 */
(function() {
  angular.module('fitboxTheme', ['theme'])

  .config([
    '$provide', function($provide) {
      return $provide.decorator('theme', [
        '$delegate', function($delegate) {
          var themeAction;
          $delegate.name = 'fitbox';

          themeAction = '#007AFF';
          $delegate.colors = {
            primary: '#8203B2',     // @theme-primary
            accent: '#38DFF2',      // @theme-accent
            base: '#F1F1F1',        // @theme-base
            action: themeAction,    // @theme-action
            actionHover: '#0078EB', // @theme-action-hover
            shadow: '#E9ECEB',      // @theme-shadow
            brandPrimary: themeAction,
            brandSuccess: '#00BF00',
            brandInfo: '#58B8CC',
            brandWarning: '#F8941D',
            brandDanger: '#FF1E00',
            brandAttention: '#FFF200',
            chart1: '#999999',               // @chart-color1 GREY
            chart2: '#4f2b5f',               // @chart-color2 DARK PURPLE
            chart3: '#8203b2',               // @chart-color3 LIGHT PURPLE
            chart4: '#32dcf6',               // @chart-color4 AQUA
            chart5: '#52a8bb',               // @chart-color5 BLUE
            chart6: '#0bdc0b',               // @chart-color6 LIGHT GREEN
            chart7: '#098509',               // @chart-color7 DARK GREEN
            chart8: '#fff200',               // @chart-color8 YELLOW
            chart9: '#f99f1c',               // @chart-color9 ORANGE
            chart10: '#ff1e00',              // @chart-color10 RED
            chartGradientDarker: '#005cbf',  // @chart-gradient-darker
            chartGradientDark: '#007aff',    // @chart-gradient-dark
            chartGradient: '#3395ff',        // @chart-gradient
            chartGradientLight: '#66afff',   // @chart-gradient-light
            chartGradientLighter: '#99caff', // @chart-gradient-lighter
            chartGreenGradientColor1: '#0BDB0B',  // @chart-green-gradient-color1
            chartGreenGradientColor2: '#1B5E20',  // @chart-green-gradient-color2
            chartGreenGradientColor3: '#2E7D32',  // @chart-green-gradient-color3
            chartGreenGradientColor4: '#388E3C',  // @chart-green-gradient-color4
            chartGreenGradientColor5: '#43A047',  // @chart-green-gradient-color5
            chartGreenGradientColor6: '#4CAF50',  // @chart-green-gradient-color6
            chartGreenGradientColor7: '#66BB6A',  // @chart-green-gradient-color7
            chartGreenGradientColor8: '#81C784',  // @chart-green-gradient-color8
            chartGreenGradientColor9: '#A5D6A7',  // @chart-green-gradient-color9
            chartGreenGradientColor10: '#C8E6C9', // @chart-green-gradient-color10
            chartRedGradientColor1: '#FF1E00',    // @chart-red-gradient-color1
            chartRedGradientColor2: '#B71C1C',    // @chart-red-gradient-color2
            chartRedGradientColor3: '#C62828',    // @chart-red-gradient-color3
            chartRedGradientColor4: '#D32F2F',    // @chart-red-gradient-color4
            chartRedGradientColor5: '#E53935',    // @chart-red-gradient-color5
            chartRedGradientColor6: '#F44336',    // @chart-red-gradient-color6
            chartRedGradientColor7: '#EF5350',    // @chart-red-gradient-color7
            chartRedGradientColor8: '#E57373',    // @chart-red-gradient-color8
            chartRedGradientColor9: '#EF9A9A',    // @chart-red-gradient-color9
            chartRedGradientColor10: '#FFCDD2'    // @chart-red-gradient-color10
          };

          $delegate.fonts = {
            global: '400 12px Roboto, Questrial, sans-serif',
            legend: '400 12px Roboto, Questrial, sans-serif',
            axisLabel: '400 11px Roboto, Questrial, sans-serif',
            axisTitle: '400 13px Roboto, Questrial, sans-serif'
          };
          $delegate.chart = {
            font: 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif'
          };


          $delegate.icons = {
            meter:             ['fitbox-icon', 'fitbox-icon-menu-home'],
            calendar:          ['fitbox-icon', 'fitbox-icon-menu-calendar'],
            bullhorn:          ['fitbox-icon', 'fitbox-icon-menu-person'],
            guide:             ['icomoon', 'icon-bubble-notification2'],
            dumbbell:          ['icomoon', 'icon-dumbbell'],
            graph:             ['fitbox-icon', 'fitbox-icon-menu-graph'],
            'band-aid':        ['icomoon', 'icon-patch'],
            'first-aid-kit':   ['icomoon', 'icon-aid'],
            clipboard:         ['icomoon', 'icon-clipboard'],
            'star-jump':       ['icomoon', 'icon-accessibility'],
            shield:            ['icomoon', 'icon-shield2'],
            'shopping-cart':   ['icomoon', 'icon-cart4'],
            cog:               ['fitbox-icon', 'fitbox-icon-menu-cog'],
            envelope:          ['icomoon', 'icon-envelop'],
            images:            ['icomoon', 'icon-images'],
            key:               ['icomoon', 'icon-key'],
            video:             ['icomoon', 'icon-youtube'],
            wrench:            ['icomoon', 'icon-wrench'],
            trophy:            ['icomoon', 'icon-trophy2'],
            tree:              ['icomoon', 'icon-tree2'],
            ticket:            ['icomoon', 'icon-ticket'],
            'pie-report':      ['icomoon', 'icon-stats3'],
            stack:             ['icomoon', 'icon-stack'],
            radio:             ['icomoon', 'icon-radio'],
            'pie-chart':       ['icomoon', 'icon-pie4'],
            building:          ['icomoon', 'icon-office'],
            notebook:          ['icomoon', 'icon-notebook'],
            dashboard:         ['icomoon', 'icon-dashboard'],
            home:              ['icomoon', 'icon-home3'],
            inbox:             ['icomoon', 'icon-drawer'],
            cube:              ['icomoon', 'icon-cube'],
            bed:               ['icomoon', 'icon-bed2'],
            balance:           ['icomoon', 'icon-balance'],
            books:             ['icomoon', 'icon-books'],
            briefcase:         ['icomoon', 'icon-briefcase'],
            clock:             ['icomoon', 'icon-clock4'],
            'location-marker': ['icomoon', 'icon-location3'],
            moon:              ['icomoon', 'icon-moon'],
            sliders:           ['icomoon', 'icon-settings'],
            smiley:            ['icomoon', 'icon-smiley2'],
            card:              ['icomoon', 'icon-vcard'],
            health:            ['icomoon', 'icon-heart6'],
            report:            ['icomoon', 'icon-stats-up'],
            'context-menu':    { "class": 'material-icons', content: 'more_vert' },
            add:               { "class": 'material-icons', content: 'add'    },
            remove:            { "class": 'material-icons', content: 'remove' },
            paid:              { "class": 'material-icons', content: 'paid'  }
          };

          return $delegate;
        }
      ]);
    }
  ]);
}).call(this);
